var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scene-list-box"},_vm._l((_vm.sceneData),function(item,index){return _c('SceneItem',{key:index,attrs:{"data":item,"level":index},on:{"sceneClick":_vm.sceneClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }